import { setupClass } from '../Base.js'

const CHARS_PER_TICK = 4
const TICK_MS = 16

// Receives growing text chunks and trickles them into settledText via a timer,
// giving a smooth character-by-character animation effect.
export class TextAnimator {
  init() {
    this.fullText = ''
    this.settledText = ''
    this._timer = null
    this.charsPerTick = CHARS_PER_TICK
    this.tickMs = TICK_MS
  }

  // Call with the complete text received so far (not just the new chunk)
  setText(text) {
    this.fullText = text
    if (!this._timer && this.settledText.length < this.fullText.length) {
      this._scheduleTick()
    }
  }

  getSettledText() {
    return this.settledText
  }

  isSettled() {
    return this.settledText.length >= this.fullText.length
  }

  // Flush all remaining text immediately and stop the timer
  flush() {
    if (this._timer) {
      clearTimeout(this._timer)
      this._timer = null
    }
    this.settledText = this.fullText
  }

  reset() {
    if (this._timer) {
      clearTimeout(this._timer)
      this._timer = null
    }
    this.fullText = ''
    this.settledText = ''
  }

  _scheduleTick() {
    this._timer = setTimeout(() => this._tick(), this.tickMs)
  }

  _tick() {
    this._timer = null
    if (this.settledText.length >= this.fullText.length) {
      return
    }
    this.settledText = this.fullText.slice(0, this.settledText.length + this.charsPerTick)
    if (this.settledText.length < this.fullText.length) {
      this._scheduleTick()
    }
  }
}
setupClass(TextAnimator)
